module.exports = __webpack_public_path__ + "img/tour-7.de4f35ce.png";